import { render } from "./RegistrationCompanyContactTabComponent.vue?vue&type=template&id=12220c80&scoped=true"
import script from "./RegistrationCompanyContactTabComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompanyContactTabComponent.vue?vue&type=script&lang=js"

import "./RegistrationCompanyContactTabComponent.vue?vue&type=style&index=0&id=12220c80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12220c80"]])

export default __exports__